var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarmer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bg-13",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 987.94 672.06",
    width: 286.188,
    height: 194.688,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "194.688px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "194.688px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "286.188px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "hidden",
      overflowY: "hidden",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "143.094px 97.3438px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "143.094px 97.3438px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "middle",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "286.188px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", {
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .cls-bg131{fill:#f8f8ff;}\n        .cls-bg132{fill:#f5f5fc;}\n        .cls-bg133{fill:#e9edfa;}\n        .cls-bg134{fill:#bac6f2;}\n        .cls-bg135{fill:#b1c1f2;}\n        .cls-bg136{fill:#fff;}\n      "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    id: titleId
  }, "bg13") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "50% 50%",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-bg131",
    d: "M521,692s30-143,68-209,97-249,362-232,284,108,327,209,108,86,133,139,13,66,13,66Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(248, 248, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg132",
    d: "M521,692s27,30,24,37-74,85,56,111,641,38,712,6,46-48,20-81,51-1,68-35a282.55,282.55,0,0,0,23-65Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(245, 245, 252)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg133",
    d: "M1422.14,626.83S1320,526.48,1025,588.48,624,576,580,576s-46.25,116.25-46.25,116.25l890.13-27.08,2.39-7.57a27,27,0,0,0,.38-7l-.38-4.6a41.21,41.21,0,0,0-.57-4.12Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(233, 237, 250)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg134",
    d: "M520.62,691.64s-111.81-56.37,0-86.86c0,0,49-126.6,137.69-16.63,0,0,81.32-8.32,83.17,46.2,0,0,17.56,12,44.36,14.79s28.65,24.95,23.1,31.42S784,688.87,784,688.87Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 198, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg135",
    d: "M1363.61,666.88l-.09-246.29s-118.38-9.36-100.88-83.5c11.52-48.83,50.48-52.67,49.54-78.42-.68-18.6,16.23-94.76,67.33-53.27,40.37,32.78,21.4,59.81,42.25,63.65,21.35,3.93,47.4,39.84,32.92,60.9s1.65,21.84,1.65,32.37,8.56,41.15-34.88,49-51.86,10.42-51.86,10.42l3.65,245.09Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(177, 193, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg135",
    d: "M1335.28,667.85l0-123.94s-40.81-4.72-34.78-42.12c4-24.63,17.4-26.57,17.08-39.56-.23-9.38,5.6-47.8,23.21-26.87,13.92,16.53,7.38,30.17,14.56,32.11,7.36,2,16.34,20.1,11.35,30.72s.57,11,.57,16.33,3,20.76-12,24.74-15.4,4-15.4,4l.24,124.2Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(177, 193, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg134",
    d: "M1297.76,669l.12-208.45s84.11-7.92,71.68-70.7c-8.19-41.35-35.87-44.6-35.2-66.39.48-15.75-11.53-80.23-47.84-45.1-28.68,27.75-15.2,50.64-30,53.89-15.17,3.33-33.68,33.73-23.39,51.57s-1.17,18.49-1.17,27.41-6.08,34.84,24.79,41.53,36.85,8.82,36.85,8.82l-2.3,207.54Z",
    transform: "translate(-470.92 -193.2)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 198, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -470.92, -193.2)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-bg136",
    cx: 315.12,
    cy: 218.48,
    r: 23.87,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: "315.12px",
      cy: "218.48px",
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: "23.87px",
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-bg136",
    cx: 234.38,
    cy: 217.9,
    r: 23.87,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: "234.38px",
      cy: "217.9px",
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: "23.87px",
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-bg136",
    cx: 275.64,
    cy: 216.88,
    r: 32.15,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: "275.64px",
      cy: "216.88px",
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: "32.15px",
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-bg136",
    cx: 617.74,
    cy: 165.1,
    r: 23.87,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: "617.74px",
      cy: "165.1px",
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: "23.87px",
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-bg136",
    cx: 658.99,
    cy: 164.09,
    r: 32.15,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: "658.99px",
      cy: "164.09px",
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: "32.15px",
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmer);
export default __webpack_public_path__ + "static/media/farmer.e4d9a6e8904be1b6c8f616e637b02909.svg";
export { ForwardRef as ReactComponent };